var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tag-select"},_vm._l((_vm.cachedTags),function(t){return _c('div',{key:t.name,staticClass:"tag-select-item",class:{selected:t.selected},on:{"click":function($event){return _vm.toggleTag(t)}}},[_vm._v(_vm._s(t.name))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }